import { useState } from "react";
import "./GenerateQR.css";
import { GestionHeader } from "./SiteHeader";
import { apiDownload, errorMessage } from "./api";

// Deux formats d'impression, servis par le même endpoint.
const FORMATS = {
  flyer: {
    file: "flyer-qr.pdf",
    error: "Impossible de générer le flyer",
  },
  qr: {
    file: "qr-code.pdf",
    error: "Impossible de générer le QR",
  },
};

function GenerateQR({ user, onNavigate, onLogout }) {
  // null, ou la variante en cours de génération : deux boutons, un seul état
  const [printing, setPrinting] = useState(null);
  const [error, setError] = useState("");

  const print = async (variant) => {
    const { file, error: message } = FORMATS[variant];
    setPrinting(variant);
    setError("");
    try {
      await apiDownload(
        `/api/organizations/${user.organization_id}/flyer?variant=${variant}`,
        {},
        file,
        message
      );
    } catch (e) {
      setError(errorMessage(e, message));
    }
    setPrinting(null);
  };

  if (!user.organization_id) {
    return (
      <div className="qr-container">
        <GestionHeader
          user={user}
          onNavigate={onNavigate}
          title="QR Code Fidélité"
          onBack={() => onNavigate("home")}
          onHome={() => onNavigate("home")}
          onLogout={onLogout}
        />
        <main className="qr-main">
          <p className="qr-error">Aucune organisation associée à votre compte. Contactez un administrateur.</p>
        </main>
      </div>
    );
  }

  // Sans ?platform= : la page d'enrôlement détecte elle-même iPhone/Android
  const qrUrl = `/api/qr/register/${user.organization_id}`;

  return (
    <div className="qr-container">
      <GestionHeader
        user={user}
        onNavigate={onNavigate}
        title="QR Code Fidélité"
        onBack={() => onNavigate("home")}
        onHome={() => onNavigate("home")}
        onLogout={onLogout}
      />
      <main className="qr-main">
        <div className="qr-org-name">{user.organization}</div>
        <p className="qr-desc">Imprimez ce QR code et affichez-le en magasin. Un seul QR pour tous vos clients : leur téléphone est détecté automatiquement (Apple Wallet ou Google Wallet).</p>
        <div className="qr-single">
          <div className="qr-dual-item">
            <img src={qrUrl} alt="QR Code d'inscription" />
            <div className="qr-dual-label">
              <span className="qr-platform-icon">🍎</span>
              <span className="qr-platform-icon">🤖</span>
              <span>iPhone &amp; Android</span>
            </div>
            <p className="qr-hint">Apple Wallet · Google Wallet</p>
          </div>
        </div>
        {error && <p className="qr-error">{error}</p>}
        <div className="qr-print-actions">
          <button
            className="qr-btn"
            onClick={() => print("flyer")}
            disabled={printing !== null}
          >
            {printing === "flyer" ? "Génération du flyer..." : "Imprimer l'affiche complète"}
          </button>
          <button
            className="qr-btn qr-btn-outline"
            onClick={() => print("qr")}
            disabled={printing !== null}
          >
            {printing === "qr" ? "Génération du QR..." : "Imprimer le QR seul"}
          </button>
        </div>
        <p className="qr-print-hint">
          L'affiche complète reprend le visuel prêt à afficher. Le QR seul est
          centré sur une page blanche, à intégrer à votre propre support.
        </p>
      </main>
    </div>
  );
}

export default GenerateQR;
